import React, { Component } from 'react';
import { getCurrentResource } from '../../util/tools';
import PlainFullDescription from '../../components/fulldescription/PlainFullDescription';
import styles from '../../components/fulldescription/FullDescription.module.css';

import { selectTopicReference } from './util';

import { FORM_BOOK_FT } from '../../util/consts/forms';
import { CLASS_BOOK } from '../../util/consts/classes';

class BookPage extends Component {

	constructor(props) {
		super(props);
		this.resource = getCurrentResource().pages.plain.Book;
		
		this.plainInfo = {
			app: props.app,
			page: this,
			class: CLASS_BOOK,
			instanceModelId: FORM_BOOK_FT,
			instanceId: this.props.match.params.id,
			param: {}
		};
	}

	selectTopic = async (fieldReference) => {
		await selectTopicReference(fieldReference);
	}

	render() {
		return (
			<React.Fragment>
				<div className={styles.divPlainTitle}>
					{this.resource.title}
				</div>
				<PlainFullDescription plain={this.plainInfo} />
			</React.Fragment>
		)
	}
}

export default BookPage;
